<div *ngIf="currentPage == 'orgLocationUK';else otherJbCode" class="col-xs-12 grbno logindocUK">
    {{paracontent}}</div>
<ng-template #otherJbCode>
<div class="referencesContainerHomeUK grbnumber margin-B20" [ngClass]="currentPage == 'account'?'dashboard_docno':''">{{paracontent}}</div>
</ng-template>